import { WebPlugin } from '@capacitor/core';
import { getAnalytics, logEvent, setAnalyticsCollectionEnabled, setUserId, setUserProperties, } from 'firebase/analytics';
export class FirebaseAnalyticsWeb extends WebPlugin {
    async getAppInstanceId() {
        throw this.unimplemented('Not implemented on web.');
    }
    async setUserId(options) {
        const analytics = getAnalytics();
        setUserId(analytics, options.userId || '');
    }
    async setUserProperty(options) {
        const analytics = getAnalytics();
        setUserProperties(analytics, {
            [options.key]: options.value,
        });
    }
    async setCurrentScreen(options) {
        const analytics = getAnalytics();
        logEvent(analytics, 'screen_view', {
            firebase_screen: options.screenName || undefined,
            firebase_screen_class: options.screenClassOverride || undefined,
        });
    }
    async logEvent(options) {
        const analytics = getAnalytics();
        logEvent(analytics, options.name, options.params);
    }
    async setSessionTimeoutDuration(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async setEnabled(_options) {
        const analytics = getAnalytics();
        setAnalyticsCollectionEnabled(analytics, _options.enabled);
    }
    async isEnabled() {
        const enabled = window['ga-disable-analyticsId'] === true;
        return {
            enabled,
        };
    }
    async resetAnalyticsData() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map